import { ApiRequestBuilder, ApiService } from '../../../api';

import {
  Component,
  HostBinding,
  Input,
  OnChanges,
  ViewEncapsulation,
} from '@angular/core';
import { SessionService } from '../../../session';
import { find } from 'lodash';
import { isFieldValueValid } from '../../../forms/utils/is-field-value-valid';
import { validatorsConfig } from '../../../../app/config/validators';
import { NotificationsService } from '../../../notifications';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'wiki-help',
  templateUrl: './wiki-help.component.html',
  styleUrls: ['./wiki-help.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class WikiHelpComponent implements OnChanges {
  @HostBinding('class')
  readonly cssClass = 'wiki-help ml-1 ';

  @HostBinding('class.!hidden')
  hideWidget = true;

  @Input()
  sectionId!: string;

  initialized = false;
  isAdmin = false;

  currentUrl?: string;

  constructor(
    private apiService: ApiService,
    private sessionService: SessionService,
    private notificationsService: NotificationsService,
    private translateService: TranslateService,
  ) {}

  ngOnChanges() {
    this.isAdmin = this.sessionService.isAdminInCurrentTenant();
    const tenantInfo = this.apiService.getTenantInfo();
    const wikiUrls = tenantInfo?.wikiUrls || [];

    const foundUrl = find(wikiUrls, { sectionId: this.sectionId });
    if (foundUrl) {
      this.currentUrl = foundUrl.url;
    } else {
      this.currentUrl = '';
    }
    this.hideWidget = !this.isAdmin && !this.currentUrl;
  }
  async deleteUrl(): Promise<void> {
    const saveRequest = new ApiRequestBuilder('deleteTenantInfoWikiUrl')
      .replaceUrl({ sectionId: this.sectionId })
      .showError()
      .build();
    const result = await this.apiService.callApi(saveRequest);
    if (result && result.status === 'success') {
      this.notificationsService.showSuccessNotification(
        this.translateService.instant('wiki.messages.successDeleted'),
      );
      this.apiService.setTenantInfoWikiUrls(result.data);
      this.currentUrl = '';
    }
  }
  async saveUrl(): Promise<void> {
    const saveRequest = new ApiRequestBuilder('updateTenantInfoWikiUrl')
      .replaceUrl({ sectionId: this.sectionId })
      .setBody({
        url: this.currentUrl,
      })
      .showError()
      .build();
    const result = await this.apiService.callApi(saveRequest);
    if (result && result.status === 'success') {
      this.notificationsService.showSuccessNotification(
        this.translateService.instant('wiki.messages.successUpdate'),
      );
      this.apiService.setTenantInfoWikiUrls(result.data);
    }
  }

  goToUrl(): void {
    window.open(this.currentUrl, '_blank');
  }

  isInvalidUrl(): boolean {
    return !isFieldValueValid(
      this.currentUrl,
      true,
      validatorsConfig['url'].value,
    );
  }
}
